// extracted by mini-css-extract-plugin
module.exports = {"cxh832a":"cxh832a","u1b9z3yn":"u1b9z3yn","ls6ua1w":"ls6ua1w","a72nx7o":"a72nx7o"};